import React from 'react';
import { CssBaseline } from '../../components';
import { ForgotUsernamePasswordSelect } from '../../components/pages/ForgotUsernamePasswordSelect';
import { withLang } from '../../server/withUser';

const ForgotUsernamePassword = () => (
  <CssBaseline>
    <ForgotUsernamePasswordSelect />
  </CssBaseline>
);

export const getServerSideProps = withLang();
export default ForgotUsernamePassword;
